import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (error) {
      setError(error.message);
    } else {
      navigate('/');
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--off-white)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
    }}>
      <div style={{ width: '100%', maxWidth: '400px' }}>

        {/* Branding */}
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <div style={{
            fontFamily: 'var(--font-heading)',
            fontSize: '2.6rem',
            fontWeight: 600,
            color: 'var(--charcoal)',
            lineHeight: 1.1,
            marginBottom: '0.2rem',
          }}>
            SEO & GEO
          </div>
          <div style={{
            fontFamily: 'var(--font-heading)',
            fontSize: '1.1rem',
            fontWeight: 400,
            color: 'var(--charcoal-muted)',
            letterSpacing: '0.06em',
            marginBottom: '0.75rem',
          }}>
            Intelligence Hub
          </div>
          <div style={{
            display: 'inline-block',
            width: '36px',
            height: '2px',
            background: 'var(--blush)',
            borderRadius: '999px',
            marginBottom: '0.75rem',
          }} />
          <div style={{
            fontFamily: 'var(--font-body)',
            fontSize: '0.75rem',
            fontWeight: 400,
            color: 'var(--charcoal-muted)',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
          }}>
            Powered by Pivot &amp; Prosper
          </div>
        </div>

        {/* Card */}
        <div style={{
          background: 'var(--white)',
          border: '1px solid var(--border)',
          borderRadius: 'var(--radius-md)',
          boxShadow: 'var(--shadow-md)',
          padding: '2.25rem 2rem',
        }}>
          <h2 style={{
            fontFamily: 'var(--font-heading)',
            fontSize: '1.5rem',
            fontWeight: 600,
            color: 'var(--charcoal)',
            marginBottom: '0.2rem',
          }}>
            Sign in
          </h2>
          <p style={{
            fontFamily: 'var(--font-body)',
            fontSize: '0.82rem',
            color: 'var(--charcoal-muted)',
            marginBottom: '1.75rem',
          }}>
            Enter your credentials to access your dashboard.
          </p>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '1.1rem' }}>
              <label style={labelStyle}>Email Address</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
                autoComplete="email"
                style={inputStyle}
                onFocus={e => e.target.style.borderColor = 'var(--blush-dark)'}
                onBlur={e => e.target.style.borderColor = 'var(--border)'}
              />
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={labelStyle}>Password</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                autoComplete="current-password"
                style={inputStyle}
                onFocus={e => e.target.style.borderColor = 'var(--blush-dark)'}
                onBlur={e => e.target.style.borderColor = 'var(--border)'}
              />
            </div>

            {error && (
              <div style={{
                fontFamily: 'var(--font-body)',
                fontSize: '0.8rem',
                color: '#B91C1C',
                background: '#FDECEA',
                border: '1px solid #FCA5A5',
                borderRadius: 'var(--radius-sm)',
                padding: '0.6rem 0.85rem',
                marginBottom: '1.25rem',
              }}>
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                background: loading ? 'var(--blush-light)' : 'var(--blush)',
                color: 'var(--charcoal)',
                fontFamily: 'var(--font-body)',
                fontWeight: 500,
                fontSize: '0.95rem',
                letterSpacing: '0.03em',
                padding: '0.8rem 1rem',
                borderRadius: 'var(--radius-sm)',
                border: 'none',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'background 0.2s ease',
              }}
              onMouseEnter={e => { if (!loading) e.currentTarget.style.background = 'var(--blush-dark)'; }}
              onMouseLeave={e => { if (!loading) e.currentTarget.style.background = 'var(--blush)'; }}
            >
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
          </form>
        </div>

        {/* Footer note */}
        <p style={{
          textAlign: 'center',
          fontFamily: 'var(--font-body)',
          fontSize: '0.75rem',
          color: 'var(--charcoal-muted)',
          marginTop: '1.5rem',
        }}>
          Access is by invitation only. Contact your administrator if you need access.
        </p>
      </div>
    </div>
  );
}

const labelStyle = {
  fontFamily: 'var(--font-body)',
  fontSize: '0.7rem',
  fontWeight: 500,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
  color: 'var(--charcoal-muted)',
  display: 'block',
  marginBottom: '0.35rem',
};

const inputStyle = {
  fontFamily: 'var(--font-body)',
  fontSize: '0.9rem',
  color: 'var(--charcoal)',
  background: 'var(--white)',
  border: '1.5px solid var(--border)',
  borderRadius: 'var(--radius-sm)',
  padding: '0.65rem 0.85rem',
  width: '100%',
  outline: 'none',
  transition: 'border-color 0.15s',
  boxSizing: 'border-box',
};
